import { Route, createBrowserRouter, createRoutesFromElements } from "react-router";
import { Root } from "@/pages/Root";
import SurveyView from "./views/survey";
import EvaluacionView from "./views/evaluacion";
import { ProtectedRoute } from "./pages/ProtectedRoute";
import { MainViewPage } from "@/pages";
import { ValidarOTP } from "./pages/ValidarOTP";
import { NotFoundPage } from "./pages/404";
import { NavBar } from "./components";

export const router = createBrowserRouter(
	createRoutesFromElements(
		<Route Component={Root}>
			<Route Component={NavBar}>
				<Route path={`/ValidarOTP/:otp`} element={<ValidarOTP />} />

				<Route element={<ProtectedRoute />}>
					<Route path='/' element={<MainViewPage />} />

					<Route path='/encuestas/:encuestaId' element={<SurveyView />} />

					<Route path='/evaluaciones/:cToken' element={<EvaluacionView key={window.location.pathname} />} />
				</Route>

				<Route path="/encuestaToken/:encuestaToken" element={<SurveyView validarPorToken />} />

			</Route>
				<Route path='*' element={<NotFoundPage />} />
		</Route>
	)
);
